import styled from "styled-components";
import { secondaryButton } from "../../styles/mixins";

export const Container = styled.section`
  padding-top: 100px;
  background: rgba(0,0,0,0);
  font-size: clamp(16px, 2vw, 24px);

  .home-body{
    display: flex;
    justify-content: space-between;
    gap: 8rem;
  }

  .home-title h1{
    font-size: clamp(1.6rem, 4.5vw, 4.2rem);
    line-height: 1.1;
    margin: 0;
  }

  .highlight{
    color: var(--green);
  }

  .subhead{
    font-size: clamp(1.2rem, 2.2vw, 1.8rem);
    font-weight: 400;
    line-height: 1.4;
    margin: 1.5rem 0 0;
    opacity: 0.9;
    max-width: 46ch;
  }

  .center {
    text-align: center;
  }

    .home-text{
    flex: 3 1 75%;
    min-width: 0;

    & > p{
      font-size: 1.8rem;
    }
    h1{
      font-size: clamp(1.94rem, 5.45vw, 5.08rem);
    }

    h3{
      color:var(--green);
      margin: 1rem 0;
    }

    
    p.small-resume {
      margin-bottom: 5rem;
    }
  }

  .button{
    margin-top: 5rem;
    padding: 1.4rem 6rem;
  }

  .home-image{
    flex: 1 1 33.333%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: clamp(12px, 2vw, 20px);

    img{
      max-width: 100%;
      width: 100%;
      height: auto;
      border-radius: 16px;
      margin: auto;

      @media(max-width: 600px){
        max-width: 250px;
      }
    }
  }

  /* Bullet list styling for home paragraphs */
  .bullet-list p{
    position: relative;
    margin: 0.75rem 0;
    padding-left: 1.5rem;
  }

  .bullet-list p::before{
    content: "";
    position: absolute;
    left: 0;
    top: 0.6em;
    width: 0.6rem;
    height: 0.6rem;
    background: var(--green);
    border-radius: 50%;
  }

  /* Actions at bottom of Home section */
  .home-actions{
    display: flex;
    gap: 1.2rem;
    align-items: stretch;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 2rem;
  }

  .home-actions .button{
    margin-top: 0;
    padding: 1.2rem 2.4rem;
    font-size: clamp(16px, 2vw, 24px);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${secondaryButton}


  @media(max-width: 960px){
    display: block;
    .home-body{
      flex-direction: column;
      align-items: center;
      gap: 2.4rem;
    }
    .home-text{

      h1{
        font-size: 3.87rem;
      }
    }
    
    .home-image{
      display: flex;
    }
  }

  @media(max-width: 500px){
    display: block;
    .home-body{
      flex-direction: column;
      align-items: center;
      gap: 2.4rem;
    }
    .home-text{

      h1{
        font-size: 3.15rem;
      }
    }
    
    .home-image{
      display: flex;
    }
  }
`